import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withLocalize } from 'react-localize-redux';
import { popupActions } from '../../store/popupStore';
import { domainActions } from '../../store/domainStore';
import { getNested, isNullOrUndefined, isFunction } from '../../store/storeFunctions';
import UpravitIcon from "../../img/icons/Upravit";

import './popupMultiSelectButton.css';

class PopupMultiSelectButton extends React.Component {
    static defaultProps = {
        readOnly: false
    }

    state = { hasData: false };
    componentDidMount() {
        const domData = this.getDomainData(this.props.data, this.props.domain, this.props.customDomain)
        if (domData !== undefined && domData.isRequesting === false && domData.requestResult === null) {
            this.props.ensureDomainData(this.props.data);
        }
    }

    getDomainData = (path, domain, customDomain) => {
        if (customDomain)
            return { requestResult: customDomain, isRequesting: false }
        else
            return path.indexOf('.') === -1 ? domain[path] : getNested(domain, path);
    }

    componentDidUpdate() {
        const selection = isNullOrUndefined(this.props.selection) || isNullOrUndefined(this.props.selection.all) ? [] : this.props.selection.all.slice(0);
        var convert = true;
        if (selection.length > 0 && isNullOrUndefined(selection[0].value))
            convert = false;
        const domData = this.getDomainData(this.props.data, this.props.domain, this.props.customDomain)
        if (this.isInitialized()) {
            let reselected = [];
            this.getSelected(reselected, domData.requestResult, convert ? selection.map(i => i.value) : selection);
            if (this.props.selection)
                this.props.selection.all = reselected.slice(0);
        } else {
            this.props.ensureDomainData(this.props.data);
        }

        if (selection.length > 0 && !this.state.hasData) {
            this.setState({ hasData: true });
        } else if (selection.length === 0 && this.state.hasData) {
            this.setState({ hasData: false });
        }
    }
    isInitialized() {
        const domData = this.props.customDomain ? { requestResult: this.props.customDomain, isRequesting: false } : this.getDomainData(this.props.data, this.props.domain, this.props.customDomain);
        return !isNullOrUndefined(domData) && domData.requestResult !== null && !domData.isRequesting;
    }

    render() {
        if (this.props.asLink) {
            return <span onClick={this.onButtonClick}>{this.props.linkText}</span>;
        }

        const st = this.props.selection ? (this.props.selection.all || []).map(x => x.label).join(';') : '';
        return (
            <div className={classnames({ 'horizontal': this.props.horizontal })}>
                {this.props.placeholder && <label>{this.props.placeholder}</label>}
                <div className={classnames({ "control": true, 'has-data': this.state.hasData })}>
                    <div className='input' onClick={this.onButtonClick} style={{ cursor: this.props.disabled ? 'not-allowed' : 'pointer', height: "2.5em" }} title={st.replace(/<sup>/g, ' (').replace(/<\/sup>/g, ')')}>
                        {this.renderInputContent()}
                    </div>
                </div>
                {!this.isInitialized() && this.renderLoading()}
            </div>
        )
    }
    renderInputContent = () => {
        return (
            <div className="multi-select-inner">
                <div>{this.props.selection ? this.selectionCount() : '-'}&nbsp;{this.props.translate("Common.SelectedItems")}</div>
                <div className={classnames({ "link-internal": true, "is-disabled": this.props.disabled })}><UpravitIcon fill="#ff8800" style={{ width: "25px", height: "25px" }} />{this.props.translate("Common.Button.Update")}</div>
            </div>
        )
    }
    selectionCount = () => {
        var all = this.props.selection.all || [];
        var parents = [];
        all.forEach(a => { parents.push(a.parentId) });
        parents = this.unique(parents);
        if (!this.props.splitParentAndChild && !this.props.splitOnlyParent) {
            all = all.filter(f => parents.indexOf(f.value) === -1);
        }
        return all.length;
    }
    renderLoading = () => {
        return <div style={{ width: '100%', height: 2 }}><div className="search-progress searching" style={{ height: 2 }}></div></div>;
    }

    getSelected = (result, root, ids) => {
        for (let index = 0; index < root.length; index++) {
            if (ids.slice(0).includes(root[index].value)) {
                result.push(root[index]);
            }
            if (root[index].children !== null && root[index].children !== undefined && root[index].children.length > 0) {
                this.getSelected(result, root[index].children, ids);
            }
        }
    }

    onButtonClick = () => {
        if (!this.props.disabled) {
            if (typeof this.props.onClick === 'function') {
                this.props.onClick();
            };
            this.props.showPopup('multiSelect', {
                open: true,
                popupSize: this.props.popupSize,
                style: { ...this.props.style, ...this.getFixedHeight(this.props.popupSize) },
                ok: () => {
                    this.props.hidePopup();
                    if (isFunction(this.props.onClosed)) {
                        this.props.onClosed(this.props.selection);
                    }
                },
                close: () => { this.props.hidePopup(); },
                isInPopup: true,
                data: this.props.data,
                customDomain: this.props.customDomain,
                title: this.props.title,
                selection: this.props.selection,
                hasRadioButtons: this.props.hasRadioButtons,
                handleChange: this.handleChange,
                onScroll: this.props.onScroll,
                paddingLeft: this.props.paddingLeft,
                readOnly: this.props.readOnly,
                splitParentAndChild: this.props.splitParentAndChild,
                splitOnlyParent: this.props.splitOnlyParent,
                treeExpanded: this.props.treeExpanded,
                disableSelectAll: this.props.disableSelectAll,
                showCustomError: this.props.showCustomError,
                maxSelectedNodes: this.props.maxSelectedNodes
            });
        }
    }

    getFixedHeight = (popupSize) => {
        switch (popupSize) {
            case 'extra-small': return { minHeight: '50vh' };
            case 'small': return { minHeight: '60vh' };
            case 'medium': return { minHeight: '70vh' };
            default: return { minHeight: '80vh' };
        }
    }

    handleChange = (allSelectedNodes, parentSelectedNodes) => {
        if (typeof this.props.handleChange === 'function') {
            this.props.handleChange(allSelectedNodes, parentSelectedNodes);
        }
    }

    unique = (array) => {
        return array.filter(function (el, index) {
            return index == array.indexOf(el);
        });
    }
}

export default withLocalize(connect(
    state => ({ popup: state.popup, domain: state.domain }),
    dispatch => bindActionCreators(({ ...popupActions, ...domainActions }), dispatch)
)(PopupMultiSelectButton));